<template lang="html">
  <div class="LoopControls">
    <!-- <input v-on:change="updateLoopState" type="checkbox" id="loopCheckbox" v-model="loopLocal">
    <label for="loopCheckbox">Loop</label>
    <input v-on:change="updateLoopState" type="checkbox" id="loopForeverCheckbox" v-model="loopForeverLocal">
    <label for="loopForeverCheckbox">Loop always</label> -->
    <button v-on:click="switchLoop"                   :class="[leftButton, {on: !disabled && loop}]"                   :disabled="disabled || loop"                     type="button" name="button">Loop:</button>
    <button v-on:click="switchLoopForever()"          :class="[middleButton, {on: !disabled && loop && loopForever}]" :disabled="disabled || loop && loopForever"  type="button" name="button">forever</button>
    <button v-on:click="switchLoopForever('once')"    :class="[rightButton, {on: !disabled && loop && !loopForever}]"                :disabled="disabled || loop && !loopForever" type="button" name="button">once</button>
    <button v-on:click="switchLoop"                   :class="[dontLoopClass, {on: !disabled && !loop}]"              :disabled="disabled || !loop"                      type="button" name="button">Don't loop</button>
    <button v-on:click="rewind()"                      class="rewind" type="button" name="button">Rewind</button>
  </div>
</template>

<script>
export default {
  name: 'LoopControls',
  props: ['loop', 'loopForever', 'disabled'],
  data: function() {
    return {
      loopLocal: {
        get: function() {
          return this.loop
        },
        set: function(newValue) {
          this.loopLocal = newValue
        }
      },
      loopForeverLocal: {
        get: function() {
          return this.loopForever
        },
        set: function(newValue) {
          this.loopForeverLocal = newValue
        }
      },
    }
  },
  computed: {
    dontLoopClass() {
      return "dontloop"
    },
    leftButton() {
      return "left-button"
    },
    middleButton() {
      return "middle-button"
    },
    rightButton() {
      return "right-button"
    },
  },
  methods: {
    updateLoopState: function() {
      this.$emit('change', {
        loop: this.loopLocal,
        loopForever: this.loopForeverLocal
      })
    },
    switchLoopForever: function(newState) {
      switch (newState) {
        case 'once':
          this.loopForeverLocal = false
          this.loopLocal = true
          break;
        default:
          this.loopForeverLocal = true
          this.loopLocal = true
        }
      this.updateLoopState()
    },
    switchLoop: function() {
      this.loopLocal = !this.loopLocal
      this.loopForeverLocal = true
      this.updateLoopState()
    },
    rewind: function() {
      this.$emit('rewind', {})
    }
  }
}
</script>

<style lang="css" scoped>
  .LoopControls {
    display: flex;
    justify-content: center;
  }
  button {
    margin: auto 1px;
    /* display: block; */

    border: none;
    border-radius:              5px;
    padding: 0.2rem 0.6rem;
    text-decoration: none;
    background: rgb(0, 90, 210);
    color: #d8e9fa;
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  button:enabled:hover {
    background-color: rgb(13, 71, 110);
  }
  button:disabled.on {
    background-color: rgb(232, 162, 57);
    color: rgb(24, 17, 10)
  }
  button:disabled {
    cursor: default;
    background-color: #4a5d63;
    color: #738b93;
  }
  .dontloop {
    margin-left: 12px;
  }
  .left-button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding-left: 0.6rem;
  }
  .middle-button {
    border-radius: 0;
  }
  .right-button {
    /* border-top-right-radius:    5px;
    border-bottom-right-radius: 5px; */
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-right: 0.6rem;
  }
  .rewind {
    margin-left: 12px;
  }

</style>
